interface ToastSimpleRowProps {
    label: string;
}

export function ToastSimpleRow({ label }: ToastSimpleRowProps) {
    return (
        <>
            <div className="text-gray-400">{label}</div>
        </>
    );
}
